<template>
  <div class="outer-wrapper">
    <van-nav-bar
      title="设备操作指导书"
      left-text="返回"
      left-arrow
      @click-left="goBack"
      fixed
    >
    </van-nav-bar>
    <div class="title-wrapper">
      <p>{{ currentEquipment.equipnum }}{{ currentEquipment.name }}</p>
    </div>

    <van-list
      v-model="tableList.loading"
      :finished="tableList.finished"
      finished-text="没有更多了"
      :error.sync="tableList.error"
      error-text="请求失败，点击重新加载"
      @load="onLoad"
    >
      <van-cell
        v-for="(item, index) in tableList.tivdata"
        :key="index + 'su'"
        :title="item.start_time + '~' + item.end_time"
      >
        <template #label>
          <div>
            <span
              >{{ projectDisplayNoAbbr(item.project_display_no) }}--{{
                item.task_name
              }}</span
            >
            <span style="float: right">{{ item.operator_name }}</span>
          </div>
        </template>
      </van-cell>
    </van-list>
  </div>
</template>
<script>
let userToken = localStorage.getItem("current_user_token");
import { textTrans } from "@/mixins/TextTrans.js";

function myTableFac() {
  return {
    loading: false,
    finished: false,
    error: false,
    Tpage: {
      currentPage: 1,
      currentSize: 20,
    },
    no_data_text: "",
    totalItems: 0,
    tivdata: [],
  };
}

const OPTIONDATA = {
  date_type: [{ text: "日期", value: "date1" }],
  order: [
    { text: "默认排序", value: "" },
    { text: "日期", value: "date1" },
  ],
  esc: [
    { text: "排序方向", value: "DESC" },
    { text: "倒序", value: "DESC" },
    { text: "顺序", value: "ESC" },
  ],
};

function optionDataFac() {
  return {
    date_type: OPTIONDATA.date_type[0].value,
    start_date: "",
    end_date: "",
    keyword: "",
    order: "",
    esc: OPTIONDATA.esc[0].value,
  };
}

export default {
  name: "equipmentWorkInstruction",
  components: {},
  mixins: [textTrans],
  props: {
    enid: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      currentTab: 0,
      currentEquipment: {
        name: "",
        equipnum: "",
      },
      tableList: myTableFac(),
      optionData: optionDataFac(),
    };
  },
  watch: {},
  computed: {},
  created() {
    this.getData();
    this.getStaticOptions();
  },
  mounted() {
  },
  methods: {
    onSearch() {
      this.tableList = myTableFac();
      this.onLoad();
    },
    getStaticOptions() {
      this.$axios
        .post(this.$url + "/ask_static_options", {
          userToken: userToken,
          ask_data: "workInstructionListForOne",
        })
        .then((response) => {
          if (response.data.stat === "ok") {
            this.staticOptions = response.data.res_record;
            this.optionData.date_type = this.staticOptions.date_type[0].value;
          } else {
            this.$Message.warning("请求选项数据失败！");
          }
        })
        .catch((error) => {
          this.$Message.warning(error + "网络错误！操作失败。");
        });
    },
    getData() {
      this.$axios
        .post(this.$url + "/equipment", {
          userToken: userToken,
          ask_data: "equipmentTotalInfo",
          enid: this.enid,
        })
        .then((response) => {
          if (response.data.stat === "ok") {
            this.currentEquipment = response.data.res_record;
            this.currentEquipment.useStat = response.data.useStat;
          } else {
            this.$toast.fail("未找到数据！");
          }
        });
    },
    onLoad() {
      this.tableList.loading = true;
      this.$axios
        .post(this.$url + "/ask_list_data", {
          page: this.tableList.Tpage,
          userToken: userToken,
          ask_data: "workInstructionListForOne",
          enid: this.enid,
          optionData: this.optionData,
        })
        .then((response) => {
          for (let ele of response.data.res_record) {
            this.tableList.tivdata.push(ele);
          }
          if (
            response.data.res_record.length < this.tableList.Tpage.currentSize
          ) {
            this.tableList.finished = true;
          }
          this.tableList.loading = false;
          this.tableList.Tpage.currentPage++;
        });
    },
    goBack() {
      window.location.href = "/equipment/" + this.enid;
    },
  },
};
</script>
<style scoped>
.inner-wrapper {
  width: 100%;
  background: #f7f7f7;
  min-height: 20rem;
}

.title-wrapper {
  text-align: center;
  font-size: 0.8rem;
  color: #999;
  padding: 1rem;
  background: #fff;
  border-bottom: 1px solid #f6f6f6;
}

.editor-wrapper {
  width: 100%;
}
.cell-item {
  margin-left: 0.6rem;
}

.op {
  outline: none;
  border: 1px solid #eee;
  color: #fff;
  background: rgb(11, 155, 18);
  font-weight: 400;
  height: 1rem;
  position: relative;
  top: 0.05rem;
  padding: 0.15rem 0.5rem;
  border-radius: 0.2rem;
}
.deny {
  background: rgb(228, 46, 14);
  margin-left: 0.5rem;
}

.text-wrapper {
  padding: 0.1rem 0.5rem;
}
.text-wrapper-con {
  padding: 1rem 0 1rem 2rem;
}

.textarea {
  width: 100%;
  height: 7rem;
}
.bold-text {
  font-weight: 600;
  color: #666;
}
.d-wrapper {
  padding: 0.5rem 1rem;
  text-align: center;
  font-size: 0.6rem;
}
.button-wrapper {
  padding: 2rem;
  text-align: center;
}
.radio-item {
  margin-top: 1rem;
  margin-left: 30%;
}

.cell-title {
  overflow: hidden;
  word-break: break-all;
}
</style>